import { CommonDepartmentTypeResponse } from '@/api/services/common/department-type/common-department-type.dto'
import { ConfigurationPersonnelDepartmentTypeAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-department-type-assignment/configuration-personnel-department-type-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState {
    departmentTypes: CommonDepartmentTypeResponse[]
    personnelDepartmentTypeAssignments: ConfigurationPersonnelDepartmentTypeAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState => ({
        departmentTypes: [],
        personnelDepartmentTypeAssignments: [],
        laboratoryId: store.getters.labId
    })
